export default "https://cdn-static.gokick.com/assets/b11b69440b74c450e5ca5f7ba176f3cdc3a0fffe/images/sleep-bottles.21ff427124b73aa7b2cf5884e65ef589.jpg";